export default "__VITE_ASSET__9c78dff9__"